/*
 * @Description: 
 * @Version: 2.0
 * @Author: zhouhong07
 * @Date: 2020-02-10 23:14:14
 * @LastEditors  : zhouhong07
 * @LastEditTime : 2020-02-15 14:12:44
 */
import React, { useEffect } from 'react';
import { Log } from '../../util/empty' ;


const SelfCity = (props) => {
  const addempty = () => {
    Log('cfCityCellClick');
  };
  return(
    <div className="cur-city-selfblock">
      <div className="cur-city-selfblock-logo" style={{background:`url(${props.data.logo}) no-repeat`,backgroundSize:"contain",backgroundPosition: "center"}}></div>
      <div className="cur-city-selfblock-name">{props.data.name}</div>
      <div className="cur-city-selfblock-more" onClick={addempty}><a href={`//qy.58.com/${props.data.id}`} target="_blank">查看在招职位</a></div>
    </div>
  )
}

export default SelfCity ;